/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Settings_Form_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Style guide settings form" |
*
* @param {Style_Guide_Manager_Settings_Form_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_settings_form_aria_label = /** @type {((inputs?: Style_Guide_Manager_Settings_Form_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Settings_Form_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Formulaire des parametres du guide de style")
	if (locale === "de") return /** @type {LocalizedString} */ ("Formular für die Einstellungen des Styleguides")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modulo di impostazioni della guida di stile")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Форма настроек руководства по стилю")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formulario de configuración de la guía de estilo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("样式指南设置表单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スタイルガイド設定フォーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्टाइल गाइड सेटिंग्स फॉर्म")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formulário de configurações do guia de estilo")
	return /** @type {LocalizedString} */ ("Style guide settings form")
});